import { CountryStateCodes } from "@taabl/common-lib/constants/CountryStateCodes";
import { Form, Formik } from "formik";
import React from "react";
import { Button } from "react-bootstrap";
import * as yup from "yup";
import FormikDropdown from "../../components/Forms/FormikDropdown";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import photo1 from "../../images/security.svg";
import FormImage from "../../layouts/formimage";
import { Constants } from "../../libs/Constants";
import { placeEvent } from "../../libs/eventsLib";
import useSignUpContext from "./contexts/useSignUpContext";

const schema = yup.object({
  address: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  zip: yup
    .number()
    .required("Zip is required")
    .min(10000, "Minimum 5 digit is required"),
  state: yup.string().required("State is required"),
  // .test("allowedStates", function(value) {
  //   if (value && !Common.ALLOWED_STATES_FOR_SIGNUP.includes(value)) {
  //     return this.createError({
  //       message:
  //         "We are working to be able to legally lend in your area. We will send you an e-mail when we are able to lend in your area.",
  //       path: "state",
  //     });
  //   }
  //   return true;
  // }),
  country: yup.string().required("Country is required"),
});
const AddressDetails = ({ onSuccess, onCancel }) => {
  const { setUser, user } = useSignUpContext();
  const handleSubmit = async (values) => {
    setUser({ ...user, ...values });
    await placeEvent(
      Constants.EVENT_TYPES.ADDRESS,
      user.companyEmail.toLowerCase(),
      values
    );
    onSuccess();
  };
  return (
    <FormImage
      title="Personalizing your Account"
      subtitle="Getting all the final details to setup your account."
      image={photo1}
      bgClass="background-green"
    >
      <React.Fragment>
        <h2 className="text-center pb-3">Address</h2>
      </React.Fragment>
      <Formik
        validationSchema={schema}
        onSubmit={handleSubmit}
        initialValues={{
          address: user.address || "",
          city: user.city || "",
          zip: user.zip || null,
          state: user.state || "",
          country: user.country || "USA",
        }}
      >
        {({ isValid, isSubmitting, values }) => (
          <Form className="w-100">
            <FormikTextField
              size="lg"
              controlId="address"
              label="Address"
              type="text"
              name="address"
              className="mb-4"
            />
            <FormikDropdown
              options={CountryStateCodes}
              placeholder="Select Country"
              size="lg"
              controlId="country"
              label="Country"
              type="text"
              name="country"
              className="mb-4"
              optionVal="iso3"
            />
            <div className="d-flex mb-4">
              <FormikTextField
                size="lg"
                controlId="city"
                label="City"
                type="text"
                className={"me-1"}
                name="city"
              />
              <FormikDropdown
                size="lg"
                options={
                  values.country !== "" && values.country !== "Select Country"
                    ? CountryStateCodes.filter(
                        (c) => c.iso3 === values.country
                      )[0].states
                    : []
                }
                placeholder="Select State"
                controlId="state"
                label="State"
                type="text"
                name="state"
                optionVal="state_code"
                className={"me-1"}
              />
              <FormikTextField
                size="lg"
                controlId="zip"
                label="Zip"
                type="number"
                name="zip"
              />
            </div>

            <LoaderButton
              block
              type="submit"
              variant="primary"
              size="lg"
              text="Continue"
              className="mb-2"
              isLoading={isSubmitting}
              disabled={!isValid || isSubmitting}
            >
              Continue
            </LoaderButton>
          </Form>
        )}
      </Formik>
      <div className="d-flex pb-4 justify-content-center font-secondary account">
        <Button variant="link" onClick={onCancel} className="secondary ps-1">
          {"< Back"}
        </Button>
      </div>
    </FormImage>
  );
};

export default AddressDetails;
